import React, { useCallback, useContext, useState } from 'react'
import styled, { ThemeContext }  from 'styled-components'
import { AutoRow } from '../Row'

import selectArtworkImg from '../../assets/ido/select_nft.svg'
import sortAscCur from '../../assets/ido/sort_asc_cur.svg'
import sortAsc from '../../assets/ido/sort_asc.svg'
import IconArrowSort from '../../assets/ido/icon_arrow_sort.svg'
import IconArrowDown from '../../assets/svg/icon_arrow_down.svg'

interface SelectProps {
  children?: React.ReactNode
  selectedValue?: any
  height?: number
  margin?: string
  top?: string
  right?: string
  bottom?: string
  left?: string
  minWidth?: number
  maxHeight?: number
  showList?: boolean
  bg?: string
  radius?: string
  pd?: string
  icon?: string
  listRadius?: string
  select?: string
  wd?: string
  img?: string
  border?: string
}

const SelectWrapper = styled.div<SelectProps>`
  position: relative;
  margin: ${({margin}) => margin ? margin : '0'}px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: ${({height}) => height ? height : 32}px;
  user-select: none;
  padding: ${({pd}) => pd ? pd : '0px'};
  background: ${({bg}) => bg ? bg : ''};
  font-family: 'Roboto-Medium';
  font-size: 14px;
  border-radius: ${({radius}) => radius ? radius : '0px'};
  border: 1px solid ${({border}) => border ? border : 'none'};
`
const HideInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0;
  width: 100%;
  height: 100%;
`
const SelectedItem = styled.div<SelectProps>`
  color: ${({theme}) => theme.bsText10};
  font-size: 14px;
  width: 100%;
  color: ${({theme}) => theme.bsText33};
`
export const MintSelectedItem = styled(SelectedItem)`
  margin-left: 13px;
  color: ${({theme}) => theme.bsText33};
  img {
    margin-right: 9px;
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }
`
const IconArrow = styled.img`
margin-left: 8px;
`
const ListWrapper = styled.div<SelectProps>`
  position: absolute;
  top: ${({top, bottom}) => top ? top : bottom ? 'initial' : '100%'};
  bottom: ${({top, bottom}) => top || !bottom ? 'initial' : bottom};
  left: ${({left, right}) => left ? left : right ? 'initial' : '0px'};
  right: ${({left, right}) => left || !right ? 'initial' : right};
  background: ${({theme }) => theme.bsBg38};
  border-radius: 8px;
  box-shadow: ${({theme, showList}) => showList ? theme.darkMode ? '0px 0px 10px rgba(0, 0, 0, 0.16)' : '0px 0px 10px rgba(171, 133, 115, 0.16)' : 'none'};
  min-width: ${({ minWidth }) => minWidth ? minWidth : '100'}px;
  max-width: 300px;
  width: 100%;
  max-height: ${({ showList, maxHeight }) => !showList ? 0 : maxHeight ? maxHeight : 300}px;
  overflow-x: hidden;
  overflow-y: auto;
  transition: all .3s;
  z-index: 5;
  opacity: 1;
`
const UlElement = styled.ul`
  margin: 0;
  padding: 12px 0;
  width: 100%;
`

export const curClassName = 'CURSELEST'

export const OptionItem = styled.li.attrs({
  curClassName
})<{ wd?: string; pd?: string; size?: string; weight?: string; select?: string; img?: string }>`

  &.${curClassName} {
    color: ${({theme}) => theme.bsText33};
  }

  display: flex;
  justify-content: space-between;
  color: ${({theme}) => theme.bsText35};
  font-size: ${({ size }) => size ? size : '14px'};
  line-height: ${({ img }) => img ? '46px' : '24px'};
  padding: ${({ pd }) => pd ? pd : '6px 16px'};
  width: ${({ wd, img }) => img ? '100%' : wd ? wd : 'auto'};
  &:hover {
    background: ${({theme}) => theme.bsBg39};
    color: ${({theme}) => theme.bsText22};
  }
`

export function Select({
  children,
  selectedValue,
  height,
  margin,
  top,
  right,
  bottom,
  left,
  minWidth,
  maxHeight,
  bg,
  radius,
  pd,
  icon,
  border
}: SelectProps) {
//   const theme = useContext(ThemeContext)
  const [showList, setShowList] = useState(false)
  const onFocus = useCallback(() => {
    setShowList(true)
  }, [])
  const onBlur = useCallback(() => {
    setShowList(false)
  }, [])

  return (
    <SelectWrapper height={height} bg={bg} radius={radius} pd={pd} margin={margin} border={border}>
      {
        selectedValue.img
        ? <MintSelectedItem>
            {
                !['collection'].includes(selectedValue.img) ? <img src={selectedValue.img} alt=""/>  : ''
            }
            { selectedValue.name }
            </MintSelectedItem>
        : <SelectedItem>{ selectedValue }</SelectedItem>
    }
      <IconArrow src={icon || IconArrowDown} alt="icon"/>
      <HideInput onFocus={onFocus} onBlur={onBlur} />
      <ListWrapper
        top={top}
        right={right}
        bottom={bottom}
        left={left}
        minWidth={minWidth}
        maxHeight={maxHeight}
        showList={showList}
      >
        <UlElement>
          { children }
        </UlElement>
      </ListWrapper>
    </SelectWrapper>
  )
}
  
export const ItemImg = styled.img<{ d?: OptionProps; cur?: OptionProps }>`
  width: auto;
  visibility: ${({d, cur}) => d?.key === cur?.key ? 'visible' : 'hidden'};
`
export const ItemLeftImg = styled.img<{ d?: OptionProps}>`
  width: 18px;
  height: 18px;
`
export const ItemDesc = styled.img<{ d?: OptionProps }>`
  transform: ${({d}) => d?.sortBy === 'desc' ? 'rotate(180deg)' : '0'};
`
export const MintName = styled.div<{d?: OptionProps}>`
  flex-grow: 1;
  font-family: 'Roboto-Bold';
  font-size: 14px;
`

export interface OptionProps {
  sortName: string
  sortBy: string
  key: number
  name: string
  isTab?: boolean,
  img?: string
}

interface SortPetsProps {
  margin?: string
  curSelect: OptionProps
  options: OptionProps[]
  updateData: (value: OptionProps) => void
  height?: number
  top?: string
  bg?: string
  select?: string
  wd?: string
  img?: string
  border?: string
}

export default function SortPets({margin, curSelect, options, updateData, height, top, bg, select, wd, img, border}: SortPetsProps) {
  const theme = useContext(ThemeContext)
  const onSelect = useCallback((d) => {
    updateData(d)
  }, [updateData])

  return (
    <Select
      selectedValue={img ? curSelect : curSelect.name}
      height={height || 40}
      margin={margin}
      top={top || '50px'}
      right='0px'
      minWidth={110}
      bg={bg ? bg : theme.btnBg1}
      radius={img ? '8px' : '40px'}
      pd='0 16px'
      listRadius='10px'
      select={select}
      border={border || 'none'}
      wd={wd}
      icon={curSelect.isTab ? IconArrowDown : IconArrowSort}
    >
      {
        options.map((d) => {
          return (
            <OptionItem
              key={d.key}
              pd={d.img ? "0 38px 0 16px"  : "6px 16px"}
              size="12px"
              weight="bold"
              select={select}
              wd={wd ? wd : '72px'}
              img={d.img}
              onMouseDown={() => {
                onSelect(d)
              }}
              className={d.key === curSelect.key ? curClassName : ''}
            >
              <AutoRow>
                {
                  d.img ? <ItemLeftImg d={d} src={d.img} alt=""/> : ''
                }
                <MintName d={d}>{d.name}</MintName>
                <ItemImg d={d} cur={curSelect} src={selectArtworkImg} alt=""/>
              </AutoRow>
              {
                !d.isTab ? <ItemDesc d={d} src={d.key === curSelect.key ? sortAscCur : sortAsc} alt=""/> : ''
              }
            </OptionItem>
          )
        })
      }
    </Select>
  )
}
